/* Spotlight: product page (options → variant, gallery, add to bag without leaving the page) and the bag count. */
(() => {
  const pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;
  const form = document.getElementById('pdp-form');
  const idInput = form.querySelector('[data-variant-id]');
  const addBtn = form.querySelector('[data-add]');
  const added = form.querySelector('[data-added]');
  const err = form.querySelector('[data-error]');
  const priceEl = pdp.querySelector('[data-price]');
  const main = pdp.querySelector('[data-main]');
  const mainImg = main.querySelector('img');
  const stamp = main.querySelector('[data-stamp]');
  const thumbs = [...pdp.querySelectorAll('.thumbs button')];
  let variants = [];
  try { variants = JSON.parse(document.querySelector('[data-variants]').textContent); } catch (e) {}
  const sets = [...form.querySelectorAll('.opt')];
  const optionCount = variants[0] ? variants[0].options.length : 0;

  function show(btn) {
    if (!btn || !mainImg) return;
    thumbs.forEach(t => t.setAttribute('aria-pressed', String(t === btn)));
    mainImg.removeAttribute('srcset');
    mainImg.src = btn.dataset.src;
    mainImg.srcset = btn.dataset.srcset;
    mainImg.alt = btn.dataset.alt || '';
    const shot = btn.dataset.shot === 'true';
    main.classList.toggle('is-cut', !shot);
    if (stamp) stamp.hidden = !shot;
  }
  thumbs.forEach(b => b.addEventListener('click', () => show(b)));

  // the chosen value of each option, in order; options with a single value (e.g. One Size) have no fieldset
  function chosen() {
    const vals = [];
    for (let i = 0; i < optionCount; i++) {
      const set = form.querySelector(`.opt[data-option="${i}"]`);
      const checked = set && set.querySelector('input:checked');
      vals.push(checked ? checked.value : null);
    }
    return vals;
  }
  function match(vals) {
    return variants.find(v => v.options.every((o, i) => vals[i] === null || vals[i] === o));
  }
  function markAvailability(vals) {
    // grey out values that have no available variant with the other current choices
    sets.forEach(set => {
      const i = +set.dataset.option;
      set.querySelectorAll('label').forEach(l => {
        const input = l.querySelector('input');
        const test = vals.slice(); test[i] = input.value;
        const ok = variants.some(v => v.available && v.options.every((o, j) => test[j] === null || test[j] === o));
        l.classList.toggle('is-out', !ok);
      });
    });
  }
  function update(fromUser) {
    const vals = chosen();
    const v = match(vals);
    sets.forEach(set => { const c = set.querySelector('input:checked'); const s = set.querySelector('[data-chosen]'); if (c && s) s.textContent = c.value; });
    markAvailability(vals);
    added.hidden = true; err.hidden = true;
    if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
    idInput.value = v.id;
    priceEl.innerHTML = v.price + (v.compare ? ` <s>${v.compare}</s>` : '');
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? `Add to bag · ${v.priceShort}` : 'Sold out';
    if (fromUser && v.media) show(thumbs.find(t => t.dataset.media === String(v.media)));
    if (fromUser && history.replaceState) {
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    }
  }
  form.addEventListener('change', e => { if (e.target.matches('.opt input')) update(true); });
  update(false);

  form.addEventListener('submit', async e => {
    e.preventDefault();
    if (addBtn.disabled) return;
    const label = addBtn.textContent;
    addBtn.disabled = true; addBtn.textContent = 'Adding…'; err.hidden = true;
    try {
      const r = await fetch(window.SP.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +idInput.value, quantity: 1 }] }) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Could not add that.');
      const cart = await (await fetch(window.SP.cart + '.js', { headers: { Accept: 'application/json' } })).json();
      document.querySelectorAll('[data-bag-count]').forEach(n => { n.textContent = cart.item_count; });
      added.hidden = false;
    } catch (x) {
      err.textContent = x.message; err.hidden = false;
    } finally {
      addBtn.disabled = false; addBtn.textContent = label;
    }
  });
})();
